import type { DealListItem } from '../../types';

/**
 * One-shot arrival hint (spec §3.6). `pending_update` (from a Pipeline badge /
 * field-update email) means "open the pending update, keep Pending/Mine".
 * `new_deal` (from a new-deal-suggestion email) means "this is a new-deal
 * candidate". Consumed once on arrival, then stripped from the URL by DealsPage
 * so it can't re-fire on reload or ride along in a copied link.
 *
 * The deal selection itself is read via `useSelectionParam('deal_key')`; the
 * legacy `?key=` alias is migrated to `?deal_key=` once on mount in DealsPage.
 */
export function readIntentFromUrlSearch(search: string): string | null {
  return new URLSearchParams(search).get('intent');
}

export function resolveEffectiveSelectedDealKey(
  selectedKey: string | null,
  deals: Pick<DealListItem, 'deal_key'>[],
): string | null {
  if (selectedKey) return selectedKey;
  return deals[0]?.deal_key ?? null;
}
